import * as form from '../form';
import {i18n} from './i18n';

class Form extends form.Form {
  protected override checkValidity() {
    const email = this.form['user[email]'];
    const confirmation = this.form['user[email_confirmation]'];
    if (email.value == confirmation.value)
      return true;
    for (const control of [email, confirmation]) {
      control.classList.add('invalid-input');
      control.setCustomValidity(i18n('signup.different'));
    }
    return false;
  }
}

form.Form.register('signup', Form);
